import CrmTable from "./CrmTable";

export default CrmTable;
